import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';
import { ITitleSearchRequestData } from '../../../types/order/title/ITitleSearchRequest';
import { IRedVisionSearchData } from '../../../types/order/title/IRedVisionSearch';

export interface ITitleSearchRequestsState {
  titleSearchRequest: { [orderId: string]: ITitleSearchRequestData[] };
  redVisionSearch: { [orderId: string]: IRedVisionSearchData };
  titleSearchRequestFetchStatus: IFetchStatus;
  titleSearchRequestError: string | null;
  redVisionSearchFetchStatus: IFetchStatus;
  redVisionSearchError: string | null;
  createTitleSearchRequestFetchStatus: IFetchStatus;
  createTitleSearchRequestError: string | null;
  cancelTitleSearchRequestFetchStatus: IFetchStatus;
  cancelTitleSearchRequestError: string | null;
}

export const titleSearchRequestsInitialState: ITitleSearchRequestsState = {
  titleSearchRequest: {},
  redVisionSearch: {},
  titleSearchRequestFetchStatus: createDefaultFetch(),
  titleSearchRequestError: null,
  redVisionSearchFetchStatus: createDefaultFetch(),
  redVisionSearchError: null,
  createTitleSearchRequestFetchStatus: createDefaultFetch(),
  createTitleSearchRequestError: null,
  cancelTitleSearchRequestFetchStatus: createDefaultFetch(),
  cancelTitleSearchRequestError: null,
};
